<template>
  <div class="complaint_order">
    <!--申诉工单头部-->
    <div class="complaint_order_top">
      <!--class="w_percent15"-->
      <div><input type="text" title="工单号/交易流水号" placeholder="工单号/交易流水号" v-model.trim="orderNum"></div>
     <!-- <div>
        <el-select v-model="selectApply" placeholder="工单申请方">
          <el-option
            v-for="item in applyList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div> -->
      <div>
        <input type="text" v-model.trim="selectAccept" placeholder="工单受理方">
       <!-- <el-select v-model="selectAccept" placeholder="工单受理方">
          <el-option
            v-for="item in acceptList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select> -->
      </div>
      <div>
        <el-select v-model="selectChannelValue" placeholder="渠道">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="selectStatus" placeholder="状态">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="w60">申诉时间:</div>
      <div>
        <el-date-picker
          v-model.trim="applyStartTime"
          type="date"
          placeholder="开始时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div class="w9">
        ~
      </div>
      <div>
        <el-date-picker
          v-model.trim="applyEndTime"
          type="date"
          placeholder="结束时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div class="w60">完结时间:</div>
      <div>
        <el-date-picker
          v-model.trim="completeStartTime"
          type="date"
          placeholder="开始时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div class="w9">
        ~
      </div>
      <div>
        <el-date-picker
          v-model.trim="completeEndTime"
          type="date"
          placeholder="结束时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
    </div>
    <button class="btn_normal fr mr10" @click="ctrlBtn('add', 0)">新增申诉工单</button>
    <button class="btn_normal fr mb10 mr10" @click="queryData()">查询</button>

    <!--申诉工单列表-->
    <div class="complaint_order_msg">
      <table class="table">
        <thead>
        <tr>
          <th>工单号</th>
          <!--<th>工单申请方</th>-->
          <th>工单受理方</th>
          <th>关联订单</th>
          <th>关联渠道</th>
          <th>申诉金额</th>
          <th>申诉原因</th>
          <th>申诉时间</th>
          <th>状态</th>
          <th>完结时间</th>
          <th>拒绝原因</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td class="no_newline">{{item.OrderNo}}</td>
          <!--<td>{{item.CreaterName}}</td>-->
          <td class="no_newline">{{item.CheckerName}}</td>
          <td class="no_newline">
            <a title="关联订单" @click="ctrlBtn('orderDetail', item)">{{item.OrderId}}</a>
          </td>
          <td>{{item.StoreroomName}}</td>
          <td>{{item.Amount}}元</td>
          <td class="wMin100 wMax250">{{item.AppealReason}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td class="no_newline">{{item.OrderStatus | complaintorderstatus}}</td>
          <td>{{item.CheckTime | time}}</td>
          <td class="wMin100 wMax250">{{item.RejectReason}}</td>
          <td style="max-width: 150px; min-width: 80px;">
            <a v-if="item.OrderStatus === 1" class="no_newline" title="修改" @click="ctrlBtn('modify', item)">修改</a>
            <a v-if="item.OrderStatus === 1" class="no_newline" title="提交" @click="checkOrderIdCreateAppealWorkOrder(item)">提交</a>
            <a v-if="item.OrderStatus === 1" class="no_newline" title="删除" @click="ctrlBtn('del', item)">删除</a>
            <a v-if="item.OrderStatus === 2 || item.OrderStatus === 4" class="no_newline" title="撤回" @click="ctrlBtn('pullBack', item)">撤回</a>
            <a class="no_newline" title="日志" @click="ctrlBtn('log', item)">日志</a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="11">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <complaint-order-embed-msg v-if="isShow && (dialogShowType !== 'orderDetail')"
                               :title="dialogTitle"
                               :orderMsg="orderMsg"
                               :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></complaint-order-embed-msg>

    <!--订单列表详情弹出框-->
    <order-list-embed-msg v-if="isShow && (dialogShowType === 'orderDetail')"
                          :title="dialogTitle"
                          :orderMsg="orderMsg"
                          :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></order-list-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import ComplaintOrderEmbedMsg from './complaint-order-embed-msg';
  import OrderListEmbedMsg from '../sales-management/order-list-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'complaint-order',
    components: {ComplaintOrderEmbedMsg, OrderListEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        orderMsg: '', // 工单信息
        list: [], // 申诉工单列表
        orderNum: '', // 工单号/订单号
        applyList: [], // 工单申请方
        selectApply: '', // 选择的工单申请方
        acceptList: [], // 工单受理方
        selectAccept: '', // 工单受理方
        channelList: [], // 渠道下拉列表
        selectChannelValue: '', // 选择的渠道列表
        statusList: [], // 状态
        selectStatus: '', // 状态
        applyStartTime: new Date(new Date() - 1000 * 60 * 60 * 24 * 30), // 申请开始时间
        applyEndTime: new Date(), // 申请结束时间
        completeStartTime: '', // 完结开始时间
        completeEndTime: '', // 完结结束时间
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取当前时间 + 30天前时间
      getTime() {
        const nowDate = new Date();
        this.applyStartTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
        this.applyEndTime = new Date();
      },

      // 加载分销商申诉工单受理方下拉信息
      getAppealWorkOrderChecker() {
        this.$axios.get(this.Global.getAppealWorkOrderChecker).then((res) => {
          if (!res.data.errorMsg.length) {
            this.acceptList = res.data.resData;
            this.acceptList.splice(0, 0, {id: '', text: '工单受理方'});
            this.selectAccept = '';
          } else {
            this.acceptList = [];
            this.selectAccept = res.data.errorMsg;
          }
        });
      },

      // 加载分销商申诉工单状态下拉数据
      getAppealWorkOrderStatus() {
        this.$axios.get(this.Global.getAppealWorkOrderStatus).then((res) => {
          if (!res.data.errorMsg.length) {
            this.statusList = res.data.resData;
            this.statusList.splice(0, 0, {id: '', text: '状态'});
            if (!this.selectStatus) {
              this.selectStatus = '';
            }
          } else {
            this.statusList = [];
            this.selectStatus = res.data.errorMsg;
          }
        });
      },

      // 加载分销商的关联渠道下拉数据
      getStoreroomIdByClientId() {
        this.$axios.get(this.Global.getStoreroomIdByClientId).then((res) => {
          if (!res.data.errorMsg.length) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 验证订单号是否已经创建过申诉工单
      checkOrderIdCreateAppealWorkOrder(item) {
        this.$axios.get(this.Global.checkOrderIdCreateAppealWorkOrder()).then((res) => {
          if (!res.data.errorMsg.length) {
            this.ctrlBtn('submit', item);
          } else {
            this.ctrlBtn('continueSubmit', item);
          }
        });
      },

      // 查询数据
      queryData() {
        if (!this.applyStartTime && !this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请时间';
          return;
        } else if (!this.applyStartTime && this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请开始时间';
          return;
        } else if (this.applyStartTime && !this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择申请结束时间';
          return;
        } else if (this.applyStartTime > this.applyEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '申请的开始时间不能大于结束时间';
          return;
        } else if (!this.completeStartTime && this.completeEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择完结开始时间';
          return;
        } else if (this.completeStartTime && !this.completeEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择完结结束时间';
          return;
        } else if (this.completeStartTime > this.completeEndTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '完结的开始时间不能大于结束时间';
          return;
        }
        this.currentPage = 1;
        this.getAppealWorkOrderList();
      },

      // 获取申诉工单分页数据
      getAppealWorkOrderList() {
        this.isLoading = true;
        const params = {
          StoreroomId: this.selectChannelValue,
          BeginCompleteTime: this.Global.timeFormatStart(this.completeStartTime),
          EndCompleteTime: this.Global.timeFormatEnd(this.completeEndTime),
          CheckerId: this.selectAccept,
          IdOrName: this.orderNum,
          Status: this.selectStatus,
          BeginCreateTime: this.Global.timeFormatStart(this.applyStartTime),
          EndCreateTime: this.Global.timeFormatEnd(this.applyEndTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getAppealWorkOrderList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.list = [];
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            } else {
              self.isLoading = false;
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsg = msg;
        switch (type) {
          case 'orderDetail':
            this.dialogTitle = '订单详情';
            break;
          case 'add':
            this.dialogTitle = '新增申诉工单';
            break;
          case 'modify':
            this.dialogTitle = '修改申诉工单';
            break;
          case 'log':
            this.dialogTitle = '操作日志';
            break;
          case 'pullBack':
            this.dialogTitle = '撤回工单';
            break;
          case 'del':
            this.dialogTitle = '删除工单';
            break;
          case 'submit':
            this.dialogTitle = '提交工单';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.currentPage = 1;
          this.getAppealWorkOrderList();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getAppealWorkOrderList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getAppealWorkOrderList();
      }
    },
    created() {
      this.getTime();
      if (this.$route.query['status']) {
        this.selectStatus = this.$route.query['status'];
      }

      this.applyStartTime = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); // 申请开始时间
      this.applyEndTime = new Date(); // 申请结束时间
      // this.getAppealWorkOrderChecker();
      this.getAppealWorkOrderStatus();
      this.getStoreroomIdByClientId();
      this.getAppealWorkOrderList();
    },
    activated() { // 只有keep-alive激活才会被使用
      this.applyStartTime = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); // 申请开始时间
      this.applyEndTime = new Date(); // 申请结束时间
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.getTime();
        this.isShow = false;
        this.completeStartTime = null;
        this.completeEndTime = null;
        this.orderNum = null;
        this.selectChannelValue = '';
        this.selectAccept = '';
        this.currentPage = 1;
        this.pageSize = 10;
        // this.getAppealWorkOrderChecker();
        this.getAppealWorkOrderStatus();
        this.getStoreroomIdByClientId();
        this.getAppealWorkOrderList();
      } else {
        if (this.$route.query['status']) {
          this.getTime();
          this.selectAccept = '';
          this.isShow = false;
          this.completeStartTime = null;
          this.completeEndTime = null;
          this.orderNum = null;
          this.applyStartTime = null;
          this.applyEndTime = null;
          this.selectChannelValue = '';
          this.currentPage = 1;
          this.pageSize = 10;
          this.selectStatus = this.$route.query['status'];
          this.getAppealWorkOrderList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .complaint_order {
    /*position: relative;*/

    .complaint_order_top {
     /* display: flex;
      justify-content: space-evenly;
      align-items: center; */
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 0 5px;

      & > div {
        display: inline-block;
        width: 10%;

        &.w_percent15 {
          width: 15%;
        }

        &.w9 {
          width: 9px;
        }

        &.w60 {
          width: 60px;
        }
      }
    }

    .complaint_order_msg {
      margin: 0 10px;
      width: calc(100% - 20px);
      height: calc(100% - 98px);
      overflow: auto;
      font-size: 12px;

      .table {
        td {
          min-width: 50px;

          a {
            margin: 0 5px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/complaint-order.vue